import { request } from 'src/apis';

export type EmergencyRequestStatus = 'PENDING' | 'ASSUMED' | 'ATTENDED';
export type EmergencyRequestSource = 'EEZYFAMILY' | 'CARE_CONNECT';

export type EmergencyRequest = {
  id: number;
  name: string;
  whatsapp: string;
  message: string;
  status: EmergencyRequestStatus;
  source: EmergencyRequestSource;
  fk_assigned_psychologist_id: number | null;
  assigned_at: string | null;
  fk_service_id: number | null;
  closed_at: string | null;
  created_at: string;
  assigned_psychologist: { id: number; name: string } | null;
};

export async function getEmergencyRequests(
  status?: EmergencyRequestStatus
): Promise<EmergencyRequest[]> {
  const params = status ? { status } : {};
  const { data } = await request.get<EmergencyRequest[]>('/emergency-requests', { params });
  return data;
}

export async function assumeEmergencyRequest(id: number): Promise<EmergencyRequest> {
  const { data } = await request.post<EmergencyRequest>(`/emergency-requests/${id}/assume`);
  return data;
}

export async function closeEmergencyRequest(
  id: number,
  serviceId?: number
): Promise<EmergencyRequest> {
  const { data } = await request.post<EmergencyRequest>(`/emergency-requests/${id}/close`, {
    service_id: serviceId,
  });
  return data;
}
